// Excedentes — algoritmo original, extraído sin modificar de js/excedentes.js.
// Verificado contra tools/caracterizacion/golden.json.

export function validar({ cantItems, cantExcedentes }) {
  if (isNaN(parseInt(cantItems, 10)) || isNaN(parseInt(cantExcedentes, 10))) {
    return 'Faltan la cantidad de ítems o de excedentes';
  }
  return null;
}

export function calcular({ sucursal, cantItems, cantExcedentes }, hoy = new Date()) {
  const anio = hoy.getFullYear();
  const mes = hoy.getMonth() + 1;
  const dia = hoy.getDate();

  const Items = parseInt(cantItems, 10);
  const Excede = parseInt(cantExcedentes, 10);
  const sucDestino = parseInt(sucursal, 10);

  let tmp = anio / (Items + 5);
  tmp = Math.round(tmp) + sucDestino;

  const tmp2 = dia * (dia % 2 == 0 ? 313 : 241);
  const tmp3 = (Excede * (Excede % 2 == 0 ? 3 : 2)) * sucDestino;
  const tmp4 = (mes * (mes % 3 == 0 ? 2 : 6)) * Excede;

  tmp = (tmp + tmp2) * Math.abs(tmp4 - tmp3);

  let Resultado = tmp % 10000;
  if (Resultado == 0) {
    Resultado = (sucDestino * dia) + Excede;
  }

  return {
    codigo: Resultado,
    // El original registraba el elemento <select> en vez de su valor y guardaba
    // "[object HTMLSelectElement]" en la auditoría; acá va el id real.
    detalle: { sucursalId: sucDestino, items: Items, excedentes: Excede },
  };
}
